// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DraftsTab-module__font-s-10___cbweg {
  font-size: 10px !important;
}

.DraftsTab-module__font-s-12___syX3g {
  font-size: 12px !important;
}

.DraftsTab-module__font-s-13___cxght {
  font-size: 13px !important;
}

.DraftsTab-module__font-s-14___keCmS {
  font-size: 14px !important;
}

.DraftsTab-module__font-s-15___vlmAB {
  font-size: 15px !important;
}

.DraftsTab-module__font-s-16___xVAKs {
  font-size: 16px !important;
}

.DraftsTab-module__font-s-18___j0zyZ {
  font-size: 18px !important;
}

.DraftsTab-module__font-s-20___NoB7Z {
  font-size: 20px !important;
}

.DraftsTab-module__font-s-22___AZSCB {
  font-size: 22px !important;
}

.DraftsTab-module__font-s-28___AGcDt {
  font-size: 28px !important;
}

.DraftsTab-module__font-w-400___UJ3P7 {
  font-weight: 400 !important;
}

.DraftsTab-module__font-w-500___NHBr7 {
  font-weight: 500 !important;
}

.DraftsTab-module__font-w-600___Ab_Q7 {
  font-weight: 600 !important;
}

.DraftsTab-module__font-w-700___csmXk {
  font-weight: 700 !important;
}

.DraftsTab-module__p-5___sL6e4 {
  padding: 5px !important;
}

.DraftsTab-module__p-12___Yhps2 {
  padding: 12px !important;
}

.DraftsTab-module__p-16___aBwkz {
  padding: 16px !important;
}

.DraftsTab-module__p-30___zRfPQ {
  padding: 30px !important;
}

.DraftsTab-module__p-b-0___NdACH {
  padding-bottom: 0 !important;
}

.DraftsTab-module__p-b-5___ZgnPz {
  padding-bottom: 5px !important;
}

.DraftsTab-module__p-b-10___RIcmY {
  padding-bottom: 10px !important;
}

.DraftsTab-module__p-b-12___Do7UY {
  padding-bottom: 12px !important;
}

.DraftsTab-module__p-b-16___UVmat {
  padding-bottom: 16px !important;
}

.DraftsTab-module__p-b-18___Tu1Xm {
  padding-bottom: 18px !important;
}

.DraftsTab-module__p-b-20___DmzXd {
  padding-bottom: 20px !important;
}

.DraftsTab-module__p-b-25___um_Nt {
  padding-bottom: 25px !important;
}

.DraftsTab-module__p-b-30___vP5k7 {
  padding-bottom: 30px !important;
}

.DraftsTab-module__p-b-50___fsoYt {
  padding-bottom: 50px !important;
}

.DraftsTab-module__p-t-0___Xrg_q {
  padding-top: 0 !important;
}

.DraftsTab-module__p-t-12___XJKU_ {
  padding-top: 12px !important;
}

.DraftsTab-module__p-t-16___zP37K {
  padding-top: 16px !important;
}

.DraftsTab-module__p-t-18___w3QiO {
  padding-top: 18px !important;
}

.DraftsTab-module__p-t-20___rXYnp {
  padding-top: 20px !important;
}

.DraftsTab-module__p-t-30___HduBW {
  padding-top: 30px !important;
}

.DraftsTab-module__p-t-40___NbDLT {
  padding-top: 40px !important;
}

.DraftsTab-module__p-t-50___ChCzz {
  padding-top: 50px !important;
}

.DraftsTab-module__p-l-20___rNsqW {
  padding-left: 20px !important;
}

.DraftsTab-module__p-l-30___lr3cB {
  padding-left: 30px !important;
}

.DraftsTab-module__p-l-40___p7C9J {
  padding-left: 40px !important;
}

.DraftsTab-module__p-r-16___F32eN {
  padding-right: 16px !important;
}

.DraftsTab-module__p-r-20___jov7r {
  padding-right: 20px !important;
}

.DraftsTab-module__p-r-30___AseQ9 {
  padding-right: 30px !important;
}

.DraftsTab-module__p-r-50___M6qHz {
  padding-right: 50px !important;
}

.DraftsTab-module__p-r-60___CFsgp {
  padding-right: 60px !important;
}

.DraftsTab-module__m-b-1___W_WWl {
  margin-bottom: 1px !important;
}

.DraftsTab-module__m-b-2___iVxWx {
  margin-bottom: 2px !important;
}

.DraftsTab-module__m-b-6___MjSRY {
  margin-bottom: 6px !important;
}

.DraftsTab-module__m-b-8___Oxpfi {
  margin-bottom: 8px !important;
}

.DraftsTab-module__m-b-10___e2V3e {
  margin-bottom: 10px !important;
}

.DraftsTab-module__m-b-14___RNg4L {
  margin-bottom: 14px !important;
}

.DraftsTab-module__m-b-16___mW6_3 {
  margin-bottom: 16px !important;
}

.DraftsTab-module__m-b-20___qC371 {
  margin-bottom: 20px !important;
}

.DraftsTab-module__m-b-22___mqE4o {
  margin-bottom: 22px !important;
}

.DraftsTab-module__m-b-24___vm6Np {
  margin-bottom: 24px !important;
}

.DraftsTab-module__m-b-30___gteR4 {
  margin-bottom: 30px !important;
}

.DraftsTab-module__m-b-32___wPgGW {
  margin-bottom: 32px !important;
}

.DraftsTab-module__m-b-40___SE9_e {
  margin-bottom: 40px !important;
}

.DraftsTab-module__m-t-2___K1QmO {
  margin-top: 2px !important;
}

.DraftsTab-module__m-t-3___BSC6Z {
  margin-top: 3px !important;
}

.DraftsTab-module__m-t-4____0W4g {
  margin-top: 4px !important;
}

.DraftsTab-module__m-t-5___fLPRu {
  margin-top: 5px !important;
}

.DraftsTab-module__m-t-8___8ztz8 {
  margin-top: 8px !important;
}

.DraftsTab-module__m-t-10___M1GpK {
  margin-top: 10px !important;
}

.DraftsTab-module__m-t-15___S615V {
  margin-top: 15px !important;
}

.DraftsTab-module__m-t-16___s73Pq {
  margin-top: 16px !important;
}

.DraftsTab-module__m-t-20___egV4G {
  margin-top: 20px !important;
}

.DraftsTab-module__m-t-22___tROPq {
  margin-top: 22px !important;
}

.DraftsTab-module__m-t-30___NSPL1 {
  margin-top: 30px !important;
}

.DraftsTab-module__m-t-32___tuZiF {
  margin-top: 32px !important;
}

.DraftsTab-module__m-l-auto___PE1Mf {
  margin-left: auto !important;
}

.DraftsTab-module__m-l-4___YAovx {
  margin-left: 4px !important;
}

.DraftsTab-module__m-l-5___RhkXC {
  margin-left: 5px !important;
}

.DraftsTab-module__m-l-6___KlQqo {
  margin-left: 6px !important;
}

.DraftsTab-module__m-l-8___Eu5YW {
  margin-left: 8px !important;
}

.DraftsTab-module__m-l-10___Hww_u {
  margin-left: 10px !important;
}

.DraftsTab-module__m-l-16___pyixf {
  margin-left: 16px !important;
}

.DraftsTab-module__m-l-20___UjiVU {
  margin-left: 20px !important;
}

.DraftsTab-module__m-l-24___dBbpD {
  margin-left: 24px !important;
}

.DraftsTab-module__m-l-30___tK5j0 {
  margin-left: 30px !important;
}

.DraftsTab-module__m-l-35___sBGWr {
  margin-left: 35px !important;
}

.DraftsTab-module__m-l-40___D1WaK {
  margin-left: 40px !important;
}

.DraftsTab-module__m-r-8___AxMnA {
  margin-right: 8px !important;
}

.DraftsTab-module__m-r-10___CtyvT {
  margin-right: 10px !important;
}

.DraftsTab-module__m-r-16___Tup2g {
  margin-right: 16px !important;
}

.DraftsTab-module__m-r-20___CSgYb {
  margin-right: 20px !important;
}

.DraftsTab-module__m-r-24___wO5b_ {
  margin-right: 24px !important;
}

.DraftsTab-module__m-r-30___crAoa {
  margin-right: 30px !important;
}

.DraftsTab-module__m-r-40___VBuJ_ {
  margin-right: 40px !important;
}

.DraftsTab-module__border-r-3___pyk16 {
  border-radius: 3px !important;
}

.DraftsTab-module__border-r-4___jAE_E {
  border-radius: 4px !important;
}

.DraftsTab-module__border-r-6___RUgMs {
  border-radius: 6px !important;
}

.DraftsTab-module__border-r-10___PLEkA {
  border-radius: 10px !important;
}

.DraftsTab-module__border-r-12___ivJjN {
  border-radius: 12px !important;
}

.DraftsTab-module__border-r-16___bgFKw {
  border-radius: 16px !important;
}

.DraftsTab-module__border-r-50___n_fPA {
  border-radius: 50% !important;
}

.DraftsTab-module__primary-border___s_wOb {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.DraftsTab-module__primary-border-b___kO8vh {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.DraftsTab-module__primary-border-t___Zy_tX {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.DraftsTab-module__primary-border-l___gEOqI {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.DraftsTab-module__primary-border-r___GXTIf {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.DraftsTab-module__secondary-border___dFIk5 {
  border: 1px solid #637768;
}

.DraftsTab-module__secondary-border-b___iKUhm {
  border-bottom: 1px solid #637768;
}

.DraftsTab-module__secondary-border-t___CnO7S {
  border-top: 1px solid #637768;
}

.DraftsTab-module__secondary-border-l___N8z0J {
  border-left: 1px solid #637768;
}

.DraftsTab-module__secondary-border-r___bx8Ph {
  border-right: 1px solid #637768;
}

.DraftsTab-module__gap-0___UBAht {
  gap: 0 !important;
}

.DraftsTab-module__gap-2___fR8hp {
  gap: 2px !important;
}

.DraftsTab-module__gap-4___bEaUQ {
  gap: 4px !important;
}

.DraftsTab-module__gap-5___RGic5 {
  gap: 5px !important;
}

.DraftsTab-module__gap-6___ZjGmW {
  gap: 6px !important;
}

.DraftsTab-module__gap-8___G1eMP {
  gap: 8px !important;
}

.DraftsTab-module__gap-10___OlfSl {
  gap: 10px !important;
}

.DraftsTab-module__gap-12___WFnTv {
  gap: 12px !important;
}

.DraftsTab-module__gap-14___JctkH {
  gap: 14px !important;
}

.DraftsTab-module__gap-16___b01bI {
  gap: 16px !important;
}

.DraftsTab-module__gap-18___MOtBW {
  gap: 18px !important;
}

.DraftsTab-module__gap-20___jBsNO {
  gap: 20px !important;
}

.DraftsTab-module__gap-24___r2zQE {
  gap: 24px !important;
}

.DraftsTab-module__gap-26___DLBWi {
  gap: 26px !important;
}

.DraftsTab-module__gap-30___Ydmda {
  gap: 30px !important;
}

.DraftsTab-module__gap-32___q91gn {
  gap: 32px !important;
}

.DraftsTab-module__gap-40___pPIwM {
  gap: 40px !important;
}

.DraftsTab-module__gap-50___nDjr1 {
  gap: 50px !important;
}

.DraftsTab-module__flex-1___x3ijl {
  flex: 1;
}

.DraftsTab-module__flex-none___xJ0BV {
  flex: none !important;
}

.DraftsTab-module__flex-column___JueW0 {
  display: flex;
  flex-direction: column !important;
}

.DraftsTab-module__flex-row___vyrnL {
  display: flex;
  flex-direction: row !important;
}

.DraftsTab-module__vertically-centered___mTIMu {
  display: flex;
  align-items: center !important;
}

.DraftsTab-module__horizontally-centered___PWB5u {
  display: flex;
  justify-content: center !important;
}

.DraftsTab-module__horizontally-end___utdBE {
  display: flex;
  justify-content: end !important;
}

.DraftsTab-module__vertically-start___QFVNY {
  display: flex;
  align-items: start !important;
}

.DraftsTab-module__space-between___WNLKY {
  display: flex;
  justify-content: space-between !important;
}

.DraftsTab-module__flex-wrap___F8G_o {
  flex-wrap: wrap !important;
}

.DraftsTab-module__height-100___Es1l7 {
  height: 100%;
}

.DraftsTab-module__width-50___jCicZ {
  width: 50% !important;
}

.DraftsTab-module__width-100___vs7Ki {
  width: 100%;
}

.DraftsTab-module__cursor-pointer___kQOvz {
  cursor: pointer;
}

.DraftsTab-module__cursor-not-allowed___kjtDa {
  cursor: not-allowed !important;
}

.DraftsTab-module__absolute-centered___veXBG {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.DraftsTab-module__absolute___Ud5f3 {
  position: absolute;
}

.DraftsTab-module__relative___mbv8n {
  position: relative;
}

.DraftsTab-module__fixed___kiCSr {
  position: fixed;
}

.DraftsTab-module__visible___BK8jZ {
  opacity: 1;
}

.DraftsTab-module__invisible___s8Ue9 {
  opacity: 0;
}

.DraftsTab-module__col-90___XdzKe {
  width: 90% !important;
}

.DraftsTab-module__col-auto___niH0C {
  width: auto !important;
}

.DraftsTab-module__medical-tabs___hVkmu {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.DraftsTab-module__medical-table-new___zg_xM {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.DraftsTab-module__medical-table-new___zg_xM:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DraftsTab-module__medical-table-new___zg_xM::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DraftsTab-module__medical-table-new___zg_xM::-webkit-scrollbar-track {
  display: none;
}
.DraftsTab-module__medical-table-new___zg_xM.DraftsTab-module__no-pagination___M_6bF {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.DraftsTab-module__medical-table-new___zg_xM.DraftsTab-module__no-pagination___M_6bF:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DraftsTab-module__medical-table-new___zg_xM.DraftsTab-module__no-pagination___M_6bF::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DraftsTab-module__medical-table-new___zg_xM.DraftsTab-module__no-pagination___M_6bF::-webkit-scrollbar-track {
  display: none;
}

.DraftsTab-module__medical-table-empty___SKFIr {
  padding: 14px 40px !important;
}

.DraftsTab-module__icon-btn___MwZg8 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.DraftsTab-module__search-icon___xqYYd {
  width: 24px;
  height: 24px;
  align-self: center;
}

.DraftsTab-module__disable-select___dzQ6y {
  user-select: none;
}

.DraftsTab-module__break-word___bx4O_ {
  word-break: break-word;
}

.DraftsTab-module__popup-clear-btn___hNSH1 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.DraftsTab-module__scroll-m-b-20___GknZv {
  scroll-margin-bottom: 20px;
}

.DraftsTab-module__table___vg0sL {
  width: 100%;
  height: calc(100vh - 53px - var(--patient-details-footer) - 200px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.DraftsTab-module__table___vg0sL:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DraftsTab-module__table___vg0sL::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DraftsTab-module__table___vg0sL::-webkit-scrollbar-track {
  display: none;
}
.DraftsTab-module__table___vg0sL .DraftsTab-module__empty___iDCtk {
  padding: 14px 40px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/fragments/DocumentationFragment/tabs/DraftsTab/DraftsTab.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,WAAA;ECOA,kEDNwB;ECOxB,kBAAA;EACA,kBAAA;ADwpBF;ACtpBE;EACE,oCAAA;EACA,mBAAA;ADwpBJ;ACrpBE;EACE,UAAA;EACA,6BAAA;ADupBJ;ACppBE;EACE,aAAA;ADspBJ;AAzqBE;EACE,kBAAA;AA2qBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.table {\n  width: 100%;\n  @include verticalScroll(calc(100vh - #{$top-navigation} - var(--patient-details-footer) - 200px));\n\n  .empty {\n    padding: 14px 40px;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `DraftsTab-module__font-s-10___cbweg`,
	"fontS12": `DraftsTab-module__font-s-12___syX3g`,
	"fontS13": `DraftsTab-module__font-s-13___cxght`,
	"fontS14": `DraftsTab-module__font-s-14___keCmS`,
	"fontS15": `DraftsTab-module__font-s-15___vlmAB`,
	"fontS16": `DraftsTab-module__font-s-16___xVAKs`,
	"fontS18": `DraftsTab-module__font-s-18___j0zyZ`,
	"fontS20": `DraftsTab-module__font-s-20___NoB7Z`,
	"fontS22": `DraftsTab-module__font-s-22___AZSCB`,
	"fontS28": `DraftsTab-module__font-s-28___AGcDt`,
	"fontW400": `DraftsTab-module__font-w-400___UJ3P7`,
	"fontW500": `DraftsTab-module__font-w-500___NHBr7`,
	"fontW600": `DraftsTab-module__font-w-600___Ab_Q7`,
	"fontW700": `DraftsTab-module__font-w-700___csmXk`,
	"p5": `DraftsTab-module__p-5___sL6e4`,
	"p12": `DraftsTab-module__p-12___Yhps2`,
	"p16": `DraftsTab-module__p-16___aBwkz`,
	"p30": `DraftsTab-module__p-30___zRfPQ`,
	"pB0": `DraftsTab-module__p-b-0___NdACH`,
	"pB5": `DraftsTab-module__p-b-5___ZgnPz`,
	"pB10": `DraftsTab-module__p-b-10___RIcmY`,
	"pB12": `DraftsTab-module__p-b-12___Do7UY`,
	"pB16": `DraftsTab-module__p-b-16___UVmat`,
	"pB18": `DraftsTab-module__p-b-18___Tu1Xm`,
	"pB20": `DraftsTab-module__p-b-20___DmzXd`,
	"pB25": `DraftsTab-module__p-b-25___um_Nt`,
	"pB30": `DraftsTab-module__p-b-30___vP5k7`,
	"pB50": `DraftsTab-module__p-b-50___fsoYt`,
	"pT0": `DraftsTab-module__p-t-0___Xrg_q`,
	"pT12": `DraftsTab-module__p-t-12___XJKU_`,
	"pT16": `DraftsTab-module__p-t-16___zP37K`,
	"pT18": `DraftsTab-module__p-t-18___w3QiO`,
	"pT20": `DraftsTab-module__p-t-20___rXYnp`,
	"pT30": `DraftsTab-module__p-t-30___HduBW`,
	"pT40": `DraftsTab-module__p-t-40___NbDLT`,
	"pT50": `DraftsTab-module__p-t-50___ChCzz`,
	"pL20": `DraftsTab-module__p-l-20___rNsqW`,
	"pL30": `DraftsTab-module__p-l-30___lr3cB`,
	"pL40": `DraftsTab-module__p-l-40___p7C9J`,
	"pR16": `DraftsTab-module__p-r-16___F32eN`,
	"pR20": `DraftsTab-module__p-r-20___jov7r`,
	"pR30": `DraftsTab-module__p-r-30___AseQ9`,
	"pR50": `DraftsTab-module__p-r-50___M6qHz`,
	"pR60": `DraftsTab-module__p-r-60___CFsgp`,
	"mB1": `DraftsTab-module__m-b-1___W_WWl`,
	"mB2": `DraftsTab-module__m-b-2___iVxWx`,
	"mB6": `DraftsTab-module__m-b-6___MjSRY`,
	"mB8": `DraftsTab-module__m-b-8___Oxpfi`,
	"mB10": `DraftsTab-module__m-b-10___e2V3e`,
	"mB14": `DraftsTab-module__m-b-14___RNg4L`,
	"mB16": `DraftsTab-module__m-b-16___mW6_3`,
	"mB20": `DraftsTab-module__m-b-20___qC371`,
	"mB22": `DraftsTab-module__m-b-22___mqE4o`,
	"mB24": `DraftsTab-module__m-b-24___vm6Np`,
	"mB30": `DraftsTab-module__m-b-30___gteR4`,
	"mB32": `DraftsTab-module__m-b-32___wPgGW`,
	"mB40": `DraftsTab-module__m-b-40___SE9_e`,
	"mT2": `DraftsTab-module__m-t-2___K1QmO`,
	"mT3": `DraftsTab-module__m-t-3___BSC6Z`,
	"mT4": `DraftsTab-module__m-t-4____0W4g`,
	"mT5": `DraftsTab-module__m-t-5___fLPRu`,
	"mT8": `DraftsTab-module__m-t-8___8ztz8`,
	"mT10": `DraftsTab-module__m-t-10___M1GpK`,
	"mT15": `DraftsTab-module__m-t-15___S615V`,
	"mT16": `DraftsTab-module__m-t-16___s73Pq`,
	"mT20": `DraftsTab-module__m-t-20___egV4G`,
	"mT22": `DraftsTab-module__m-t-22___tROPq`,
	"mT30": `DraftsTab-module__m-t-30___NSPL1`,
	"mT32": `DraftsTab-module__m-t-32___tuZiF`,
	"mLAuto": `DraftsTab-module__m-l-auto___PE1Mf`,
	"mL4": `DraftsTab-module__m-l-4___YAovx`,
	"mL5": `DraftsTab-module__m-l-5___RhkXC`,
	"mL6": `DraftsTab-module__m-l-6___KlQqo`,
	"mL8": `DraftsTab-module__m-l-8___Eu5YW`,
	"mL10": `DraftsTab-module__m-l-10___Hww_u`,
	"mL16": `DraftsTab-module__m-l-16___pyixf`,
	"mL20": `DraftsTab-module__m-l-20___UjiVU`,
	"mL24": `DraftsTab-module__m-l-24___dBbpD`,
	"mL30": `DraftsTab-module__m-l-30___tK5j0`,
	"mL35": `DraftsTab-module__m-l-35___sBGWr`,
	"mL40": `DraftsTab-module__m-l-40___D1WaK`,
	"mR8": `DraftsTab-module__m-r-8___AxMnA`,
	"mR10": `DraftsTab-module__m-r-10___CtyvT`,
	"mR16": `DraftsTab-module__m-r-16___Tup2g`,
	"mR20": `DraftsTab-module__m-r-20___CSgYb`,
	"mR24": `DraftsTab-module__m-r-24___wO5b_`,
	"mR30": `DraftsTab-module__m-r-30___crAoa`,
	"mR40": `DraftsTab-module__m-r-40___VBuJ_`,
	"borderR3": `DraftsTab-module__border-r-3___pyk16`,
	"borderR4": `DraftsTab-module__border-r-4___jAE_E`,
	"borderR6": `DraftsTab-module__border-r-6___RUgMs`,
	"borderR10": `DraftsTab-module__border-r-10___PLEkA`,
	"borderR12": `DraftsTab-module__border-r-12___ivJjN`,
	"borderR16": `DraftsTab-module__border-r-16___bgFKw`,
	"borderR50": `DraftsTab-module__border-r-50___n_fPA`,
	"primaryBorder": `DraftsTab-module__primary-border___s_wOb`,
	"primaryBorderB": `DraftsTab-module__primary-border-b___kO8vh`,
	"primaryBorderT": `DraftsTab-module__primary-border-t___Zy_tX`,
	"primaryBorderL": `DraftsTab-module__primary-border-l___gEOqI`,
	"primaryBorderR": `DraftsTab-module__primary-border-r___GXTIf`,
	"secondaryBorder": `DraftsTab-module__secondary-border___dFIk5`,
	"secondaryBorderB": `DraftsTab-module__secondary-border-b___iKUhm`,
	"secondaryBorderT": `DraftsTab-module__secondary-border-t___CnO7S`,
	"secondaryBorderL": `DraftsTab-module__secondary-border-l___N8z0J`,
	"secondaryBorderR": `DraftsTab-module__secondary-border-r___bx8Ph`,
	"gap0": `DraftsTab-module__gap-0___UBAht`,
	"gap2": `DraftsTab-module__gap-2___fR8hp`,
	"gap4": `DraftsTab-module__gap-4___bEaUQ`,
	"gap5": `DraftsTab-module__gap-5___RGic5`,
	"gap6": `DraftsTab-module__gap-6___ZjGmW`,
	"gap8": `DraftsTab-module__gap-8___G1eMP`,
	"gap10": `DraftsTab-module__gap-10___OlfSl`,
	"gap12": `DraftsTab-module__gap-12___WFnTv`,
	"gap14": `DraftsTab-module__gap-14___JctkH`,
	"gap16": `DraftsTab-module__gap-16___b01bI`,
	"gap18": `DraftsTab-module__gap-18___MOtBW`,
	"gap20": `DraftsTab-module__gap-20___jBsNO`,
	"gap24": `DraftsTab-module__gap-24___r2zQE`,
	"gap26": `DraftsTab-module__gap-26___DLBWi`,
	"gap30": `DraftsTab-module__gap-30___Ydmda`,
	"gap32": `DraftsTab-module__gap-32___q91gn`,
	"gap40": `DraftsTab-module__gap-40___pPIwM`,
	"gap50": `DraftsTab-module__gap-50___nDjr1`,
	"flex1": `DraftsTab-module__flex-1___x3ijl`,
	"flexNone": `DraftsTab-module__flex-none___xJ0BV`,
	"flexColumn": `DraftsTab-module__flex-column___JueW0`,
	"flexRow": `DraftsTab-module__flex-row___vyrnL`,
	"verticallyCentered": `DraftsTab-module__vertically-centered___mTIMu`,
	"horizontallyCentered": `DraftsTab-module__horizontally-centered___PWB5u`,
	"horizontallyEnd": `DraftsTab-module__horizontally-end___utdBE`,
	"verticallyStart": `DraftsTab-module__vertically-start___QFVNY`,
	"spaceBetween": `DraftsTab-module__space-between___WNLKY`,
	"flexWrap": `DraftsTab-module__flex-wrap___F8G_o`,
	"height100": `DraftsTab-module__height-100___Es1l7`,
	"width50": `DraftsTab-module__width-50___jCicZ`,
	"width100": `DraftsTab-module__width-100___vs7Ki`,
	"cursorPointer": `DraftsTab-module__cursor-pointer___kQOvz`,
	"cursorNotAllowed": `DraftsTab-module__cursor-not-allowed___kjtDa`,
	"absoluteCentered": `DraftsTab-module__absolute-centered___veXBG`,
	"absolute": `DraftsTab-module__absolute___Ud5f3`,
	"relative": `DraftsTab-module__relative___mbv8n`,
	"fixed": `DraftsTab-module__fixed___kiCSr`,
	"visible": `DraftsTab-module__visible___BK8jZ`,
	"invisible": `DraftsTab-module__invisible___s8Ue9`,
	"col90": `DraftsTab-module__col-90___XdzKe`,
	"colAuto": `DraftsTab-module__col-auto___niH0C`,
	"medicalTabs": `DraftsTab-module__medical-tabs___hVkmu`,
	"medicalTableNew": `DraftsTab-module__medical-table-new___zg_xM`,
	"noPagination": `DraftsTab-module__no-pagination___M_6bF`,
	"medicalTableEmpty": `DraftsTab-module__medical-table-empty___SKFIr`,
	"iconBtn": `DraftsTab-module__icon-btn___MwZg8`,
	"searchIcon": `DraftsTab-module__search-icon___xqYYd`,
	"disableSelect": `DraftsTab-module__disable-select___dzQ6y`,
	"breakWord": `DraftsTab-module__break-word___bx4O_`,
	"popupClearBtn": `DraftsTab-module__popup-clear-btn___hNSH1`,
	"scrollMB20": `DraftsTab-module__scroll-m-b-20___GknZv`,
	"table": `DraftsTab-module__table___vg0sL`,
	"empty": `DraftsTab-module__empty___iDCtk`
};
module.exports = ___CSS_LOADER_EXPORT___;
